import { z } from "zod";

const UTM_MAX_LENGTH = 100;
const UTM_MAX_ITEMS = 50;

/**
 * Client-only People properties (UTM attribution). Field names ARE the People
 * property names; the server chooses the Mixpanel operation per field
 * (set_once for first-touch, union for accumulating lists) and resolves the
 * profile from the authenticated user — the client never sends an identity.
 */
export const SetPeopleDtoSchema = z.object({
  initialSourceUtm: z.string().min(1).max(UTM_MAX_LENGTH).optional(),
  sourcesUtmFromUrl: z.array(z.string().min(1).max(UTM_MAX_LENGTH)).max(UTM_MAX_ITEMS).optional(),
  sourcesUtm: z.array(z.string().min(1).max(UTM_MAX_LENGTH)).max(UTM_MAX_ITEMS).optional(),
});

export type SetPeopleDtoType = z.infer<typeof SetPeopleDtoSchema>;
